import { Injectable } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApprovalService {
  approvalData = {
    attachmentsData: null,
    attachmentsRepresentatives: null,
    representative: null,
    representativeSignStatus: null,
    signs: null,
    risk: null,
    composition: null,
    complementary_data: null,
    powers: null,
    history: null,
    signatures: null,
    service_providers: null,
    professional: null,
    income: null,
    version: null,
    revision: null,
    mainRevision: null,
    mainVersion: null,
    comparingRevision: null,
    comparingVersion: null,
    originalRevision: null,
    originalVersion: null,
    activeTab: null, // Aba ativa atual
    v3LoadingCount: 0, // Contador de requisições v3 em andamento
    approval: null, // Approval principal para sincronização
  };

  changeVersion = new EventEmitter();
  changeMainVersion = new EventEmitter();
  changeComparingVersion = new EventEmitter();
  updateRepresentativeSignStatus = new EventEmitter();
  updateApprovalQueue = new EventEmitter(); // Evento para notificar atualização de queue e current_department

  reset() {
    this.approvalData = {
      attachmentsData: null,
      attachmentsRepresentatives: null,
      representative: null,
      representativeSignStatus: null,
      signs: null,
      composition: null,
      complementary_data: null,
      powers: null,
      history: null,
      service_providers: null,
      signatures: null,
      professional: null,
      risk: null,
      income: null,
      version: null,
      revision: null,
      mainRevision: null,
      mainVersion: null,
      comparingRevision: null,
      comparingVersion: null,
      originalRevision: null,
      originalVersion: null,
      activeTab: null,
      v3LoadingCount: 0,
      approval: null,
    };
  }

  incrementV3Loading() {
    this.approvalData.v3LoadingCount++;
  }

  decrementV3Loading() {
    if (this.approvalData.v3LoadingCount > 0) {
      this.approvalData.v3LoadingCount--;
    }
  }

  isV3Loading(): boolean {
    return this.approvalData.v3LoadingCount > 0;
  }
}
